import axios from "axios";
import constants from "@/_consts";
import { getEndPoints } from "@/utils/api-call";

function getPreSignUrl(payload) {
  const url = getEndPoints().program_logo.getPresignedUrl.replace(
    ":id",
    payload.fileName
  );
  const token = sessionStorage.getItem(constants.LOCAL_STORE.accessToken);
  const refreshToken = sessionStorage.getItem(constants.LOCAL_STORE.refreshToken);
  axios
    .get(url, {
      headers: {
        ...{
          "Content-Type": "application/json",
          Authorization: token,
          "X-Auth-Token": refreshToken
        }
      }
    })
    .then(response => {
      if (response.data && response.data.presignedUrl) {
        const payloadS3 = {
          getPresignedUrl: response.data.getPresignedUrl,
          preSignUrl: response.data.presignedUrl,
          mainCallback: payload.mainCallback,
          file: payload.file,
          callback: payload.callback
        };
        payload.callback(payloadS3);
      }
    });
}

function putFileToPreSignUrl(payload) {
  const payloadS3 = {
    fileName: payload.fileName,
    mainCallback: payload.callback,
    file: payload.file,
    callback: saveFileToS3
  };
  getPreSignUrl(payloadS3);
}

function saveFileToS3(payload) {
  var options = {
    headers: {
      "Content-Type": payload.file.type
    }
  };
  axios
    .put(payload.preSignUrl, payload.file, options)
    .then(function(result) {
      result.data = payload.getPresignedUrl;
      result.dataPreview = payload.getPresignedUrl;
      payload.mainCallback(result);
    })
    .catch(function(err) {
      payload.mainCallback(err);
    });
}

export default {
  getPreSignUrl,
  putFileToPreSignUrl,
  saveFileToS3
};



// WEBPACK FOOTER //
// ./src/utils/aws-s3.js